export const SectionHead = ({ label, title, sub, testid }) => (
  <div className="mb-14 max-w-3xl" data-testid={testid}>
    <p className="mb-3 font-mono text-xs font-bold uppercase tracking-[0.25em] text-forge-soft">{label}</p>
    <h2 className="font-head text-4xl font-black uppercase leading-[0.95] tracking-tight text-steel-50 sm:text-5xl">
      {title}
    </h2>
    {sub && <p className="mt-5 text-base leading-relaxed text-steel-400 md:text-lg">{sub}</p>}
    <div className="mt-6 h-[3px] w-24 bg-forge" />
  </div>
);
